var _path, _rect, _path2, _g, _g2, _rect2, _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 129,
    viewBox: "0 0 354 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H350C351.933 0.5 353.5 2.067 353.5 4V128.5H0.5V4C0.5 2.06701 2.067 0.5 4 0.5Z",
    fill: "white",
    stroke: "#E0E6F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 18,
    width: 58,
    height: 38,
    rx: 4,
    fill: "#F0F6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.001 31.3969C307.858 30.6298 308.976 30.2201 310.126 30.2519C311.275 30.2837 312.369 30.7546 313.182 31.5679C313.995 32.3803 314.466 33.4727 314.499 34.6212C314.532 35.7697 314.124 36.8873 313.359 37.7449L306.999 44.1139L300.641 37.7449C299.875 36.8869 299.467 35.7683 299.5 34.6189C299.534 33.4695 300.006 32.3764 300.82 31.564C301.633 30.7517 302.727 30.2817 303.877 30.2507C305.026 30.2196 306.144 30.6297 307.001 31.3969ZM312.12 32.6277C311.578 32.0863 310.85 31.7727 310.084 31.7514C309.319 31.7301 308.574 32.0025 308.003 32.5129L307.002 33.4114L306 32.5137C305.428 32.0027 304.683 31.7299 303.916 31.7514C303.15 31.7729 302.421 32.087 301.879 32.6292C301.342 33.1659 301.029 33.8863 301.002 34.6449C300.975 35.4036 301.237 36.1442 301.735 36.7174L307 41.9907L312.265 36.7182C312.763 36.1447 313.025 35.4036 312.999 34.6444C312.972 33.8852 312.658 33.1645 312.12 32.6277Z",
    fill: "#185ADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 26H44C44.2652 26 44.5196 26.1054 44.7071 26.2929C44.8946 26.4804 45 26.7348 45 27V43C45 43.2652 44.8946 43.5196 44.7071 43.7071C44.5196 43.8946 44.2652 44 44 44H26C25.7348 44 25.4804 43.8946 25.2929 43.7071C25.1054 43.5196 25 43.2652 25 43V27C25 26.7348 25.1054 26.4804 25.2929 26.2929C25.4804 26.1054 25.7348 26 26 26H30V24H32V26H38V24H40V26ZM38 28H32V30H30V28H27V32H43V28H40V30H38V28ZM43 34H27V42H43V34Z",
    fill: "#8E99AD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 45C65.477 45 61 40.523 61 35C61 29.477 65.477 25 71 25C76.523 25 81 29.477 81 35C81 40.523 76.523 45 71 45ZM71 43C73.1217 43 75.1566 42.1571 76.6569 40.6569C78.1571 39.1566 79 37.1217 79 35C79 32.8783 78.1571 30.8434 76.6569 29.3431C75.1566 27.8429 73.1217 27 71 27C68.8783 27 66.8434 27.8429 65.3431 29.3431C63.8429 30.8434 63 32.8783 63 35C63 37.1217 63.8429 39.1566 65.3431 40.6569C66.8434 42.1571 68.8783 43 71 43ZM72 35H76V37H70V30H72V35Z",
    fill: "#8E99AD"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 62,
    width: 354,
    height: 67,
    fill: "url(#paint0_linear_1862_2361)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 277.5,
    cy: 20.5,
    r: 7.5,
    fill: "#EC4646"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.5,
    cy: 20.5,
    r: 4.5,
    fill: "#EC4646"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1862_2361",
    x1: 177,
    y1: 62,
    x2: 177,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FAFB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikes);
export default __webpack_public_path__ + "static/media/likes.a0889b78e96f594bf12f7937f40621cf.svg";
export { ForwardRef as ReactComponent };